<template>
  <div class="theme" style="margin-top: 10px">
    <div class="theme-item" v-for="(item, themeIndex) in themeList" :key="themeIndex">
      <div class="header flex-b-c">
        <div class="title">
          <div class="title-name">{{ item.name }}</div>
          <div class="title-content">{{ item.description }}</div>
        </div>
        <div class="functions flex-a-c" v-if="!isProgramEdit">
          <i class="sort-icon el-icon-sort-up" v-if="themeIndex !== 0" @click="upTheme(item.id, themeIndex)"></i>
          <el-button type="text" class="func" @click="handleAdd(item.id)" v-if="themeType===1 || themeType === 3">新增</el-button>
          <el-upload v-else action="/api/admin/template/addMaterial" :accept="themeType === 2 ? 'image/jpeg,image/png,image/gif,video/mp4' : 'font/ttf'" :data="uploadParams" :show-file-list="false" :before-upload="beforeUpload" :on-success="handleUploadSuccess">
            <el-button type="text" class="func" @click="addMaterial(item.id)">新增</el-button>
          </el-upload>
          <el-button type="text" class="func" @click="handleEditTheme(item)">修改</el-button>
          <el-button type="text" class="func" @click="handleDelete(item.id)">删除</el-button>
        </div>
      </div>
      <div class="content" v-if="true">
        <component :is="getComponentType()" :tempList="item.templates || []" :materialList="item.materials || []" :isProgramEdit="isProgramEdit" :count="item.count" :themeId="item.id" :themeType="themeType" @handleTempEdit="handleTempEdit" @handleTempDelete="handleTempDelete" @refresh="refresh" @loadMore="loadMore" />
      </div>
      <div class="no-data" v-else>
        暂无数据
      </div>
    </div>
    <div v-if="rubbish">
      <add-template :s_type="s_type" :openTemAdd="tempDialogVisible" :addEdit="tempAddEdit" :themeId="addThemeId" :editData="tempEditData" @closeTemAdd="closeTemAdd" v-if="rubbish">
      </add-template>
    </div>
    <font-add :visible="fontDialogVisible" :themeId="addThemeId" @closeDialog="closeFontAdd" />
  </div>
</template>

<script>
import {
  handleDataAndSign
} from "@/assets/scripts/handleDataAndSign";
import {
  uriEncode
} from "@/assets/scripts/uriEncode";
import MaterialList from "./MaterialList.vue";
import TemplateList from "./TemplateList.vue";
import AddTemplate from './AddTemplate.vue';
import FontAdd from './FontAdd.vue';

export default {
  name: "Theme",
  props: {
    themeList: {
      type: Array,
    },
    themeType: {
      type: Number
    },
    s_type: {
      type: Number
    },
    isProgramEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MaterialList,
    TemplateList,
    AddTemplate,
    FontAdd
  },
  data() {
    return {
      uploadParams: {},
      currentThemeId: 0,
      tempDialogVisible: false,
      fontDialogVisible: false,
      tempAddEdit: 'ADD',
      addThemeId: 0,
      tempEditData: {},
      rubbish: true
    };
  },
  watch: {
    tempDialogVisible(val) {
      if (!val) {
        this.rubbish = false;
        setTimeout(() => {
          this.rubbish = true;
          this.$forceUpdate();
        }, 200);
      }
    }
  },
  methods: {
    getComponentType() {
      switch (this.themeType) {
        case 1:
          return 'template-list';
        case 2:
        case 3:
          return 'material-list';
      }
    },
    handleAdd(id) {
      this.tempAddEdit = "ADD";
      this.addThemeId = id;
      switch (this.themeType) {
        case 1:
          this.tempDialogVisible = true;
          break;
        case 3:
          this.fontDialogVisible = true;
          break;
      }
    },
    handleEditTheme(theme) {
      this.$emit('editTheme', theme)
    },
    handleDelete(id) {
      this.$emit("openDelDialog", id);
    },
    handleTempEdit(temp) {
      this.tempAddEdit = "EDIT";
      this.tempDialogVisible = true;
      this.tempEditData = temp;
    },
    handleTempDelete(id) {
      this.$emit('tempDelete', id)
    },
    addMaterial(id) {
      this.currentThemeId = id;
    },
    beforeUpload(file) {
      const fileType = file.type.split('/')[0];
      const type = {
        image: 2,
        video: 1
      }[fileType];
      const formData = {
        group_id: this.$cookies.get("group_id"),
        theme_id: this.currentThemeId,
        type: this.themeType === 2 ? type : 19
      }
      const data = handleDataAndSign("/admin/template/addMaterial", formData);
      const { v, s, t, token } = data;
      this.uploadParams.v = v;
      this.uploadParams.s = s;
      this.uploadParams.t = t;
      this.uploadParams.token = token;
      this.uploadParams.group_id = formData.group_id;
      this.uploadParams.theme_id = formData.theme_id;
      this.uploadParams.type = formData.type;
    },
    handleUploadSuccess() {
      this.$emit('uploadSuccess');
    },
    refresh() {
      this.$emit('uploadSuccess');
    },
    closeTemAdd(isUpdate) {
      this.tempDialogVisible = false;
      isUpdate && this.refresh();
    },
    closeFontAdd(isRefresh) {
      this.fontDialogVisible = false;
      if (isRefresh) {
        this.refresh();
      }
    },
    loadMore(page, id) {
      this.$emit('loadMore', page, id);
    },
    upTheme(id, index) {
      const changeList = [
        { id: this.themeList[index - 1].id, sort_order: this.themeList[index].sort_order },
        { id: this.themeList[index].id, sort_order: this.themeList[index - 1].sort_order }
      ]
      this.$http.post('/admin/template/changeThemeSortOrder', {
        type: this.themeType,
        change_list: uriEncode(changeList)
      }, data => {
        if (data) {
          // 交换位置
          const topTheme = {
            ...this.themeList[index],
            sort_order: this.themeList[index - 1].sort_order
          };
          const bottomTheme = {
            ...this.themeList[index - 1],
            sort_order: this.themeList[index].sort_order
          };
          this.themeList.splice(index - 1, 2, topTheme, bottomTheme);
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.theme-item {
  // margin-top: 20px;
  .header {
    .title {
      display: flex;
      align-items: flex-end;
      .title-name {
        font-size: 25px;
        font-weight: bold;
        margin-right: 10px;
      }
      .title-content {
        color: #909399;
      }
    }
    .functions {
      .func {
        font-size: 16px;
        margin-left: 16px;
      }
      .sort-icon {
        color: #409eff;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
  .content {
    padding: 0 15px 5px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .cont {
      position: relative;
      height: 165px;
      width: 220px;

      display: flex;
      flex-direction: column;
      margin: 10px 20px;
      background-color: rgba($color: #909399, $alpha: 0.5);
      .thumb-img {
        width: 100%;
        height: 80%;
        img {
          width: 220px;
          height: 135px;
        }
      }
      .desc {
        height: 30px;
        line-height: 14px;
      }
    }
    .item-edit {
      position: absolute;
      height: 100%;
      width: 100%;
      background-color: rgba($color: #909399, $alpha: 0.5);
      .preview-image {
        margin-top: 8px;
      }
    }
  }

  .no-data {
    width: 100%;
    height: 60px;
    line-height: 60px;
    color: gray;
  }
}
</style>